import React from "react";
import { Tabs } from "antd";
import SystemIncomes from "./systemIncoms";
import SideIncomes from "./sideIncomes";
import SideExpenditures from "./sideExpenditures";
function AdminAccounting(props) {
  const items = [
    {
      label: "درآمدهای سیستمی",
      key: "systemIncomes",
      children: <SystemIncomes />,
    },
    {
      label: "درآمدهای جانبی",
      key: "sideIncomes",
      children: <SideIncomes />,
    },
    {
        label: "هزینه های جانبی",
        key: "sideExpenditures",
        children: <SideExpenditures />,
      },
  ];
  return (
    <div>
      <Tabs items={items} />
    </div>
  );
}

export default AdminAccounting;
